import { findThumbnail } from '@marketplace-web/shared/utils'

import { ItemThumbnailSize } from '../constants/item'
import { ItemPhotoDto, ItemPhotoModel } from '../types/item'

export const getItemThumbnail = (photos: Array<ItemPhotoDto>, size = ItemThumbnailSize.Medium) => {
  const photo = photos?.find(({ is_main }) => is_main)

  return findThumbnail(photo, size)
}

export const getItemPhotoThumbnail = (
  photos: Array<ItemPhotoModel> | undefined,
  size = ItemThumbnailSize.Medium,
) => {
  const photo = photos?.find(({ isMain }) => isMain)

  return findThumbnail(photo, size)
}

export const getItemPhotosThumbnails = (
  photos: Array<ItemPhotoDto>,
  size = ItemThumbnailSize.Medium,
) => {
  if (photos.length === 0) return undefined

  return photos
    .map(photo => photo.thumbnails.find(thumb => thumb.type === size)?.url)
    .filter((photoUrl): photoUrl is string => !!photoUrl)
}
